import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Logout = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M39.441,31.422c0.357,0.206 0.578,0.589 0.578,1.001c0,0.203 -0.053,0.402 -0.155,0.578c-3.211,5.562 -9.165,8.999 -15.587,8.999c-9.875,0 -18,-8.125 -18,-18c0,-9.875 8.125,-18 18,-18c6.422,0 12.376,3.437 15.587,8.999c0.102,0.176 0.156,0.376 0.156,0.579c0,0.634 -0.522,1.156 -1.157,1.156c-0.411,0 -0.794,-0.22 -1,-0.577c-2.799,-4.849 -7.988,-7.844 -13.586,-7.844c-8.607,0 -15.688,7.082 -15.688,15.688c0,8.605 7.081,15.688 15.688,15.688c5.598,-0.001 10.787,-2.996 13.586,-7.845c0.318,-0.548 1.03,-0.739 1.578,-0.422Zm-0.249,-8.578l0,-1.82c0.001,-0.634 0.523,-1.155 1.157,-1.155c0.237,0 0.47,0.073 0.664,0.21l4.222,2.976c0.306,0.217 0.488,0.57 0.488,0.945c0,0.375 -0.182,0.728 -0.488,0.945l-4.222,2.976c-0.194,0.137 -0.427,0.21 -0.664,0.21c-0.634,0 -1.156,-0.521 -1.157,-1.155l0,-1.82l-20.269,0c-0.634,0 -1.156,-0.522 -1.156,-1.156c0,-0.634 0.522,-1.156 1.156,-1.156l20.269,0Z" fill={fill} />
    </svg>
  );
};

Logout.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Logout.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
